import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import Privacy from "./pages/Privacy.tsx";
import Terms from "./pages/Terms.tsx";
import Cookies from "./pages/Cookies.tsx";
import Security from "./pages/Security.tsx";
import Contact from "./pages/Contact.tsx";
import About from "./pages/About.tsx";
import FAQ from "./pages/FAQ.tsx";
import SolutionPage from "./pages/SolutionPage.tsx";
import DPA from "./pages/DPA.tsx";
import Wooncoach from "./pages/Wooncoach.tsx";
import ScrollToTop from "./components/ScrollToTop";
import { IntentProvider } from "./intent/IntentContext";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <IntentProvider>
          <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/veelgestelde-vragen" element={<FAQ />} />
          <Route path="/wooncoach" element={<Wooncoach />} />
          <Route path="/voor-makelaars" element={<SolutionPage role="broker" />} />
          <Route path="/voor-leveranciers" element={<SolutionPage role="supplier" />} />
          {/* English /en submap */}
          <Route path="/en" element={<Index />} />
          <Route path="/en/about" element={<About />} />
          <Route path="/en/contact" element={<Contact />} />
          <Route path="/en/faq" element={<FAQ />} />
          <Route path="/en/home-advisor" element={<Wooncoach />} />
          <Route path="/en/for-agents" element={<SolutionPage role="broker" />} />
          <Route path="/en/for-vendors" element={<SolutionPage role="supplier" />} />
          <Route path="/en/privacy" element={<Privacy />} />
          <Route path="/en/terms" element={<Terms />} />
          <Route path="/en/cookies" element={<Cookies />} />
          <Route path="/en/security" element={<Security />} />
          <Route path="/en/dpa" element={<DPA />} />
          {/* Legacy EN paths (redirect via existing pages) */}
          <Route path="/for-brokers" element={<SolutionPage role="broker" />} />
          <Route path="/for-suppliers" element={<SolutionPage role="supplier" />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/security" element={<Security />} />
          <Route path="/dpa" element={<DPA />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </IntentProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
